import { IAppState } from './state'

let initialState: IAppState = {
	// user: null,
	// search: {
	// 	query: '',
	// },
	tour: null,
	filter: {
		hasCoupons: false,
		categories: []
	},
	categories: {
		selectedCategories: [],
		selectedTopCategory: { name: 'Virtual Tours', icon: '/images/icons/small-icon-virtual-tours.png', categories: [] }
	}
}

const cookieName =
	'$2y$12$1aXvMvnP2u84vafju9uy9.vTXSjvaQ.lNEPW4MYEklr0.6F2PnH22='
const cookies = document.cookie.split(';')
for (var i = 0; i < cookies.length; i++) {
	let cookie = cookies[i]
	while (cookie.charAt(0) === ' ') cookie = cookie.substring(1, cookie.length)
	if (cookie.indexOf(cookieName) === 0) {
		initialState = JSON.parse(
			cookie.substring(cookieName.length, cookie.length),
		)
		break
	}
}

export default initialState
